import React from "react";
import { ChequeCultureLegacy } from "./legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../service/ChequeCultureService";

export const SessionExpire = () => {
  const chequeCultureService = new ChequeCultureService();

  return (
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12">
        <div className="card">
          <center>
            <h2 style={{ color: "#932823" }}>
              Page expirée car ouverte depuis trop longtemps.
            </h2>
            <br />
            <h3 style={{ color: "#333031" }}>Reconnectez-vous avant de recommencer.</h3>
            <br />
            <button
              type="button"
              onClick={() => chequeCultureService.redirectEaLegacyAccueil()}
              style={{
                color: "#ffffff",
                backgroundColor: "#2A7D93",
                border: "1px solid #999898",
                padding: "0.5rem 1rem",
                fontSize: "1rem",
                borderRadius: "5px",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#39b0c8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#2A7D93")}
            >
              RETOUR A LA LISTE DES PRESTATIONS
            </button>
            <br />
            <br />
          </center>
        </div>
      </div>
    </div>
  );
};
